import * as moment from 'moment';

export class EnumModel {
  _id: string;
  Name: string;
  Type: string;
  Value: string;
}

export class ActivityRoutineModel {
  _id: number;
  UserId: number;
  Name: string;
  Notes?: string;
  ActivityItems?: any[] = [];
}

export class BodyCompositionModel {
  Height?: number;
  Weight: number;
  Age: number;
}

export class DayActivityModel {
  _id: string;
  UserId: number;
  Date: Date;
  StartTime: moment.Moment | string;
  StartTimeDisplay: string;
  Name: string;
  ActiveDuration: Number;
  DurationDisplay: string;
  Calories: Number;
  Distance: Number;
  Duration: Number;
  Steps: Number;
  ActivityCount: Number;
  ExerciseItems?: ExerciseModel[] = [];
  MaxSets?: number[] = [];
}

export class DayEntryModel {
  _id: string;
  UserId: number;
  Date: Date;
  Notes?: string;
  BodyComposition?: BodyCompositionModel;
  Hydration?: Number;
  FitbitActivityCalories: Number;
  FitbitCalories: Number;
  FitbitDistance: Number;
  FitbitSteps: Number;
  Nutrition?: NutritionModel = new NutritionModel();
  NutritionTarget?: NutritionModel;
  TargetPercentage?: NutritionModel;
  MacroPercentage?: NutritionModel;
  FoodItems?: FoodModel[] = [];
  Activities?: DayActivityModel[] = [];
  Supplements?: DaySupplementModel[] = [];
  Workouts?: WorkoutModel[] = [];
}

export class DaySupplementModel {
  _id: string;
  UserId: number;
  StartDate: Date;
  Time: moment.Moment | string;
  TimeDisplay: string;
  Name: string;
  Brand: string;
  Serving: Number;
  TotalServings: Number;
}

export class ExerciseModel {
  _id?: string;
  Name: string = '';
  Variation?: string = '';
  FullName?: string;
}

export class FoodModel {
  _id: string;
  Name: string;
  Brand: string;
  Portion: string;
  Serving: number;
  ServingSize: number;
  Notes?: string;
  Nutrition: NutritionModel = new NutritionModel();
}

export class FoodPlanModel {
  _id: string;
  UserId: number;
  Name: string;
  Notes?: string;
  Nutrition?: NutritionModel = new NutritionModel();
  TargetPercentage?: NutritionModel;
  FoodItems?: FoodModel[] = [];
}

export class MealModel {
  _id: string;
  Name: string;
  FoodCount?: number;
  FoodItems?: FoodModel[];
  Nutrition?: NutritionModel;

  constructor() {
    this.FoodItems = [];
  }
}

export class NutritionModel {
  Calories?: number;
  Fat?: number;
  Carbohydrates?: number;
  Fiber?: number;
  Sugar?: number;
  Protein?: number;

  constructor() {
    this.Calories = 0;
    this.Fat = 0;
    this.Carbohydrates = 0;
    this.Fiber = 0;
    this.Sugar = 0;
    this.Protein = 0;
  }
}

export class SupplementModel {
  _id: string;
  Name: string;
  Brand: string;
  Portion: string;
  Notes?: string;
}

export class SupplementStackModel {
  _id: string;
  Name: string;
  SupplementCount?: number;
  SupplementItems?: SupplementModel[];
  constructor() {
    this.SupplementItems = [];
  }
}

export class UserModel {
  _id: number;
  FirstName: string;
  LastName: string;
  Username: string;
  BodyHeight: number;
  BodyWeight: number;
  BirthDate: moment.Moment;
  Memo: string;
  Age?: number;
  HeightDisplay?: string;
}

export class UserMemoModel {
  _id: number;
  UserId: number;
  Name: string;
  Memo: string;
}

export class WorkoutModel {
  _id: number;
  UserId: number;
  Date: moment.Moment | string;
  Time: moment.Moment | string;
  TimeDisplay: string;
  Name: string;
  Notes: string;
  LastWorkout?: WorkoutModel;
  LastWorkoutId?: number = null;
  Exercises?: WorkoutExerciseModel[] = [];
  MaxSets?: number[] = [];
}

export class WorkoutExerciseModel {
  _id: number;
  ExerciseId: number;
  SortOrder: number;
  Name: string = '';
  Variation: string = '';
  FullName: string = '';
  Sets?: WorkoutExerciseSetModel[] = [];
}

export class WorkoutExerciseSetModel {
  _id: number;
  Weight: number | null;
  Reps: number | null;
  SortOrder: number;
}


// WEBPACK FOOTER //
// ./src/models/models.ts